<div class="main-container">
    <div class="main-page">
        <div class="prospect-detail">
            <div class="white-card">
                <div class="header-title-row">
                    <div class="header-left">
                        <img src="assets/svg/money-icon.svg" alt="Presupuestos" class="center-svg"/>
                        <h1 class="text-semibold color-org t-24">Presupuestos</h1>
                        <div class="dropdown-wrapper" #dropdownContainer>
                            <div class="dropdown-trigger" (click)="toggleRecentDropdown()">
                                <span>{{selectedItem === 'recientes' ? 'Mis presupuestos' : 'Todos los Presupuestos'}}</span>
                                <span [class.rotated]="showRecentDropdown">▼</span>
                                <div class="dropdown-menu" [class.show]="showRecentDropdown">
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'todas'" (click)="selectItem('todas')">
                                        <span class="check-icon" *ngIf="selectedItem === 'todas'">✔</span>
                                        Todos los Presupuestos
                                    </button>
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'recientes'" (click)="selectItem('recientes')">
                                        <span class="check-icon" *ngIf="selectedItem === 'recientes'">✔</span>
                                        Mis presupuestos
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="header-actions">
                        <button class="action-btn outline" *ngIf="permissionService.hasPermission('Presupuestos', 'Crear')" (click)="openMdlCreateBudget()">
                            <img class="color-org" src="assets/svg/plus-orange.svg" alt="Añadir nuevo" width="16" height="16" />
                            Nuevo presupuesto
                        </button>
                    </div>
                </div>
                <div class="header-stats mt-3">
                    <span>{{presupuestosFiltrados.length}} elementos | Se actualizó hace 2 minutos</span>
                    <span *ngIf="hasActiveFilters()" class="filter-badge" style="margin-left: 10px;">
                        Filtros aplicados
                        <button (click)="clearFilters()" class="clear-filters-btn">×</button>
                    </span>
                </div>

                <div class="content-area mt-5">
                    <div *ngIf="errorMessage" class="error-message">
                        {{errorMessage}}
                    </div>
                    <div *ngIf="!isLoading && presupuestos.length > 0">
                        <div class="d-grid search-bar-container" style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            width: 100%;
                            gap: 16px;
                        ">
                            <div class="npt-table-search-bar d-grid" style="flex: 1; min-width: 0">
                                <div><img src="assets/svg/search.svg" alt=""></div>
                                <input 
                                    type="text" 
                                    class="npt-nav-search" 
                                    placeholder="Buscar en esta lista..."
                                    [(ngModel)]="searchTerm"
                                    (input)="onSearchChange()"
                                    style="flex: 1; min-width: 0; width: 100%"
                                >
                            </div>
                            <div style="display: flex; gap: 12px; flex-shrink: 0">
                                <button class="search-btn" (click)="cargarPresupuestos()" style="display: flex; align-items: center; gap: 6px; white-space: nowrap;">
                                    <img src="assets/svg/reload-icon.svg" alt="Actualizar">
                                    <span>Actualizar</span>
                                </button>
                                <button class="search-btn" (click)="openFilterModal()" style="display: flex; align-items: center; gap: 6px; white-space: nowrap;">
                                    <img src="assets/svg/filtrar-icon.svg" alt="Filtrar">
                                    <span>Filtrar</span>
                                </button>
                            </div>
                        </div>

                        <div class="prospectos-table mh-50">
                            <table>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class="checkbox-column text-center">
                                            <img src="assets/svg/checkline-icon.svg">
                                        </th>
                                        <th 
                                            (click)="sortByColumn('nombre_presupuesto')"
                                            [class.sorted]="sortColumn === 'nombre_presupuesto'"
                                            class="sortable-header"
                                        >
                                            Nombre de Presupuesto
                                            <span *ngIf="sortColumn === 'nombre_presupuesto'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('oportunidades.nombre')"
                                            [class.sorted]="sortColumn === 'oportunidades.nombre'"
                                            class="sortable-header"
                                        >
                                            Nombre de la oportunidad
                                            <span *ngIf="sortColumn === 'oportunidades.nombre'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('fecha_caducidad')"
                                            [class.sorted]="sortColumn === 'fecha_caducidad'"
                                            class="sortable-header"
                                        >
                                            Fecha de caducidad
                                            <span *ngIf="sortColumn === 'fecha_caducidad'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('subtotal')"
                                            [class.sorted]="sortColumn === 'subtotal'"
                                            class="sortable-header"
                                        >
                                            Subtotal
                                            <span *ngIf="sortColumn === 'subtotal'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('precio_total')"
                                            [class.sorted]="sortColumn === 'precio_total'"
                                            class="sortable-header"
                                        >
                                            Precio total
                                            <span *ngIf="sortColumn === 'precio_total'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let presupuesto of presupuestosFiltrados; let i=index" [class.contacto-invalido]="!presupuesto.presupuesto_id"(click)="verDetallePresupuesto(presupuesto.presupuesto_id, $event)">
                                        <td class="counter-cell">{{ i + 1 }}.</td>
                                        <td class="checkbox-column">
                                            <input type="checkbox" (click)="$event.stopPropagation()">
                                        </td>
                                        <td>{{presupuesto.nombre_presupuesto}}</td>
                                        <td>{{ presupuesto.oportunidades?.nombre }}</td>
                                        <td>{{ presupuesto.fecha_caducidad | date:'dd/MM/yyyy' }}</td>
                                        <td>CLP {{ presupuesto.subtotal | number:'1.0-0' }}</td>
                                        <td>CLP {{ presupuesto.precio_total | number:'1.0-0' }}</td>
                                        <td class="actions-cell">
                                            <div class="dropdown-container" (click)="$event.stopPropagation()">
                                                <button class="dots-button" (click)="toggleActionsMenu('menu-' + presupuesto.presupuesto_id)">
                                                    <svg class="dots-icon" viewBox="0 0 24 24">
                                                        <circle cx="12" cy="5" r="2"/>
                                                        <circle cx="12" cy="12" r="2"/>
                                                        <circle cx="12" cy="19" r="2"/>
                                                    </svg>
                                                </button>
                                                <div class="dropdown-menu" [class.show]="openedMenuId === 'menu-' + presupuesto.presupuesto_id">
                                                    <button *ngIf="permissionService.hasPermission('Presupuestos', 'Editar')" class="dropdown-item" (click)="updateBudget(presupuesto)">Modificar</button>
                                                    <button *ngIf="permissionService.hasPermission('Presupuestos', 'Eliminar')" class="dropdown-item" (click)="openMdlDeleteBudget(presupuesto.presupuesto_id)">Eliminar</button>
                                                    <button *ngIf="permissionService.hasPermission('Presupuestos', 'Editar')" class="dropdown-item" (click)="openMdlChangeOwner(presupuesto)" >Cambiar propietario </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div *ngIf="!isLoading && presupuestos.length === 0 && !errorMessage" class="empty-state">
                        <div class="empty-content">
                            <div class="empty-image">
                                <img src="assets/img/listaprospecto.png" alt="Lista de presupuesto vacía" />
                            </div>
                            <h2>Sin Presupuestos por ahora</h2>
                            <p>Todavía no tienes Presupuestos registrados. Puedes comenzar agregando uno nuevo.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>        
</div>